import { Network } from "@/config/tokens"
import NetworkIcon from "@/components/icons/network"
import { FormControl } from "@/components/ui/form"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"

interface NetworkSelectProps {
  onChange: (value: string) => void;
  defaultValue: Network;
  networks: Network[];
}

export default function NetworkSelect({
  networks,
  onChange,
  defaultValue,
}: NetworkSelectProps) {
  return (
    <Select onValueChange={onChange} defaultValue={defaultValue}>
      <FormControl>
        <SelectTrigger>
          <SelectValue placeholder="Network" />
        </SelectTrigger>
      </FormControl>
      <SelectContent>
        {networks.map((network) => (
          <SelectItem key={network} value={network}>
            <div className="flex flex-row gap-2 items-center">
              <div className="h-6 w-6">{<NetworkIcon name={network} />}</div>
              {network}
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
